/**
 * Storage Service Facade
 * Provides unified, typed key-value operations for Web and Mobile.
 */

import { IStorageAdapter } from './storageAdapter';
import { webStorage } from './webStorageAdapter';

class StorageService {
  private adapter: IStorageAdapter;

  constructor(adapter: IStorageAdapter = webStorage) {
    this.adapter = adapter;
  }

  /** Swap storage adapter for testing or React Native (AsyncStorage) */
  setAdapter(adapter: IStorageAdapter): void {
    this.adapter = adapter;
  }

  get(key: string): string | null {
    const res = this.adapter.getItem(key);
    return typeof res === 'string' ? res : null;
  }

  set(key: string, value: string): void {
    this.adapter.setItem(key, value);
  }

  remove(key: string): void {
    this.adapter.removeItem(key);
  }

  clear(): void {
    this.adapter.clear();
  }

  getJson<T>(key: string, fallback: T): T {
    try {
      const val = this.get(key);
      return val ? (JSON.parse(val) as T) : fallback;
    } catch {
      return fallback;
    }
  }

  setJson<T>(key: string, value: T): void {
    try {
      this.set(key, JSON.stringify(value));
    } catch {
      // ignore
    }
  }
}

export const storageService = new StorageService();
export * from './storageAdapter';
export * from './webStorageAdapter';
